import { IMinerErrorsProps } from "./MinerErrors.props";
import { useMinerErrorsControl } from "./useMinerErrorsControl";
import moment from "moment";
import { useIntl } from "react-intl";
import classNames from "classnames";

import styles from "./MinerErrors.module.scss";

import warning from "@assets/icons/triangle-alert.svg";
import Icon from "@components/global/new/Icon/Icon";
import SmallLink from "@components/global/new/SmallLink/SmallLink";
import Title from "@components/global/new/Title/Title";
import { Modal } from "antd";

export default function MinerErrors(props: IMinerErrorsProps) {
  const { formatMessage } = useIntl();
  const control = useMinerErrorsControl(props);

  if (!control.errors.length && !control.errorsHistory.length) return null;

  return (
    <>
      <Modal
        open={control.show}
        onCancel={control.onToggle}
        footer={null}
        afterClose={control.onClearErrors}
      >
        {control.errors.length > 0 && (
          <div className={styles.errors_wrapper}>
            {/* <div className={styles.top}>
    <SmallLink onClick={control.onClearErrors}>
      {formatMessage({ id: "filters.clear" })}
    </SmallLink>
  </div> */}
            <div className={styles.errors_header}>
              <span>
                {formatMessage({
                  id: "machines.more.settings.miner_errors.col-1",
                })}
              </span>
              <span>
                {formatMessage({
                  id: "machines.more.settings.miner_errors.col-2",
                })}
              </span>
              <span>
                {formatMessage({
                  id: "machines.more.settings.miner_errors.col-3",
                })}
              </span>
              <span>
                {formatMessage({
                  id: "machines.more.settings.miner_errors.col-4",
                })}
              </span>
            </div>

            <div className={styles.errors}>
              {control.errors.map((error) => {
                const dataError = JSON.parse(error.Data || "{}") as {
                  code: number;
                  cause: string;
                  suggestion: string;
                };
                const time = moment(error.Timestamp * 1000);
                return (
                  <div className={styles.error_item} key={error.Id}>
                    <div>{dataError.code}</div>
                    <div>{dataError.cause}</div>
                    <div>{dataError.suggestion}</div>
                    <div>
                      {time.format("DD/MM/YYYY")} | {time.format("hh:mm")}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {control.errorsHistory && control.errorsHistory.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <Title className={styles.title}>
              {formatMessage({
                id: "machines.more.settings.miner_errors.subtitle",
              })}
            </Title>
            <div className={styles.errors_wrapper}>
              <div className={styles.errors_header}>
                <span>
                  {formatMessage({
                    id: "machines.more.settings.miner_errors.col-1",
                  })}
                </span>
                <span>
                  {formatMessage({
                    id: "machines.more.settings.miner_errors.col-2",
                  })}
                </span>
                <span>
                  {formatMessage({
                    id: "machines.more.settings.miner_errors.col-3",
                  })}
                </span>
                <span>
                  {formatMessage({
                    id: "machines.more.settings.miner_errors.col-4",
                  })}
                </span>
              </div>

              <div className={styles.errors}>
                {control.errorsHistory.map((error) => {
                  const dataError = JSON.parse(error.Data || "{}") as {
                    code: number;
                    cause: string;
                    suggestion: string;
                  };
                  const time = moment(error.Timestamp * 1000);
                  return (
                    <div className={styles.error_item} key={error.Id}>
                      <div>{dataError.code}</div>
                      <div>{dataError.cause}</div>
                      <div>{dataError.suggestion}</div>
                      <div>
                        {time.format("DD/MM/YYYY")} | {time.format("hh:mm")}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </Modal>
      <div
        className={classNames(styles.wrapper, {
          [styles.show]: control.show,
        })}
      >
        <div
          className={classNames(styles.content, {
            [styles.active]: control.show,
            [styles.hasErrors]: control.errors.length > 0,
          })}
          onClick={control.onToggle}
        >
          {/* <Title className={styles.title}>
          {formatMessage({ id: "machines.more.settings.miner_errors.title" })}
        </Title> */}
          <Icon src={warning} className={styles.icon} noHover />

          {/* {control.show && control.errors.length > 0 && (
          <SmallLink onClick={control.onClearErrors}>
            {formatMessage({ id: "filters.clear" })}
          </SmallLink>
        )} */}
        </div>
      </div>
    </>
  );
}
